import(/* webpackMode: "eager", webpackExports: ["BlogPageContent"] */ "/vercel/path0/src/components/inbound-gpt/resources-pages.tsx");
